import auxItemsMock from "__mocks__/get-items-aux.json";
import {
  AmazonianHardwareAuxWithTaxonomyID,
  AmazonianHardwareWithTaxonomyID,
  GetItemResponse,
  GetItemsResponse,
} from "@amzn/amazonian-hardware-catalogical";
import { TaxonomyIdItem } from "@amzn/taxonomy-lib";
import { CatalogicalRequestContent } from "common/types/catalogical-type";
import { CatalogicalService } from "lib/services";
import { GetItemResponsePagination } from "lib/services/catalogical-models";
import { useState } from "react";

export const amznhamMockItems = [
  {
    taxonomyId: "atn::hardware/compute/laptop/hp/model1",
    mainCategory: "compute",
    subCategory: "laptop",
    manufacturer: "hp",
    model: "model1",
    name: "Laptop HP 1",
    shortDescription: "This is the description of the item",
    internalSpecifications: [{ key: "os", value: "windows" }],
  },
  {
    taxonomyId: "atn::hardware/compute/laptop/hp/model2",
    mainCategory: "compute",
    subCategory: "laptop",
    manufacturer: "hp",
    model: "model2",
    name: "Laptop HP 2",
    shortDescription: "This is the description of the item",
  },
] as AmazonianHardwareWithTaxonomyID[];

const client = new CatalogicalService<AmazonianHardwareWithTaxonomyID>("amznham");

export interface GetItemsProps {
  searchParams: CatalogicalRequestContent;
}

export function useGetItems() {
  const [data, setItems] = useState<AmazonianHardwareWithTaxonomyID[] | undefined>(undefined);
  const [paginationInfo, setPaginationInfo] = useState<GetItemResponsePagination>({ total: 0, offset: 0, limit: 0 });
  const [error, setError] = useState<Error | undefined>(undefined);
  const [isLoading, setLoading] = useState<boolean>(false);

  async function doGetItems(props: GetItemsProps) {
    setLoading(true);

    try {
      const response = await client.getCatalogicalItems(props.searchParams);
      if (!response) {
        const err = { name: "No response", message: "No response getting the items" };
        setError(err);
        setLoading(false);
        return undefined;
      }
      setError(undefined);
      setPaginationInfo(response.pagination);
      setItems(response.data);
      setLoading(false);
      return response.data;
    } catch (err) {
      setError(err as Error);
      setLoading(false);
      return undefined;
    }
  }

  return { data, paginationInfo, error, isLoading, doGetItems };
}

export function useGetItem() {
  const [data, setItem] = useState<AmazonianHardwareWithTaxonomyID | undefined>(undefined);
  const [error, setError] = useState<Error | undefined>(undefined);
  const [isLoading, setLoading] = useState<boolean>(false);

  async function doGetItem(taxonomyId: string) {
    setLoading(true);

    try {
      const response = await client.getCatalogItemByTaxonomyId(new TaxonomyIdItem(taxonomyId));
      if (!response) {
        const err = { name: "No response", message: "No response getting the item" };
        setError(err);
        setLoading(false);
        return undefined;
      }
      setError(undefined);
      setItem(response.item);
      setLoading(false);
      return response.item;
    } catch (err) {
      setError(err as Error);
      setLoading(false);
    }
  }

  return { data, error, isLoading, doGetItem };
}

export function useGetItemsAux() {
  const [data, setItems] = useState<AmazonianHardwareAuxWithTaxonomyID[] | undefined>(undefined);
  const [error, setError] = useState<Error | undefined>(undefined);
  const [isLoading, setLoading] = useState<boolean>(true);

  async function doGetItems(props: GetItemsProps) {
    setLoading(true);
    try {
      // TODO: Fix filtering issues in Search page https://issues.amazon.com/issues/Manatee-1014

      // const response = await clientAux.getCatalogicalItems<GetItemsResponse<AmazonianHardwareAuxWithTaxonomyID>>(props.searchParams);
      // if (!response) {
      //   const err = { name: "No response", message: "No response" };
      //   console.error(err);
      //   setError(err);
      // }
      // setError(undefined);
      // setPaginationInfo(response.pagination);
      // setItems(response.data);

      const auxType = JSON.parse(props.searchParams.filter!).type as string;
      setItems((auxItemsMock as any)[auxType]);
    } catch (err) {
      console.error(err);
      setError(err as Error);
    }
    setLoading(false);
  }

  return { data, error, isLoading, doGetItems };
}
